<template lang="pug" src="./custom-contact-section.pug"></template>

<script>
import ContactForm from 'components/forms/contact-form/contact-form'

export default {
  props: {
    props: {
      Type: Object,
      default: () => ({})
    },
    app: {
      Type: Object,
      default: () => ({})
    }
  },
  components: {
    ContactForm
  }
}
</script>



// WEBPACK FOOTER //
// custom-contact-section.vue?6d49f794